import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { Pedido } from '../../../../routes/RoutesNames';
import { Alert, Tab } from '@mui/material';
import usePedidoDetalhes from '../../../../hooks/usePedidoDetalhes';
import { TabContext, TabList } from '@mui/lab';
import Box from '@mui/material/Box';
import { TabFinalidade } from './components/TabFinalidade';
import { Button } from '../../../../shared/components/button/Button';
import { TabCadastro } from './components/TabCadastro';
import { TabProduto } from './components/TabProduto';
import { TabServico } from './components/TabServico';
import { TabFinanceiro } from './components/TabFinanceiro';
import { TabTransporte } from './components/TabTransporte';
import { TabLocacao } from './components/TabLocacao';
import { TabFinalizar } from './components/TabFinalizar';
import { TabDadosAdicionais } from './components/TabDadosAdicionais';
import { ModalProductSelect } from './components/ModalProductSelect';
import { ModalServiceSelect } from './components/ModalServiceSelect';
import { Save } from '@mui/icons-material';
import { Loader } from '../../../../shared/components/Loader';
import { useParams, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { ProcessedBoletosDialog } from "../../../../shared/components/BoletosDialog";

export const PedidoDetalhes = () => {
  const { id } = useParams();
  const location = useLocation();
  const duploClick = location.state?.duploClick || false;
  const [clonar] = useState(location.state?.clonar || 'N');
  const {
    tabIndex,
    handleTabChange,
    handleNext,
    handleBack,
    isTabBlocked,
    handleSearchCustomer,
    handleAutoCompleteSelected,
    customerOptions,
    sellerOptions,
    handleSearchSeller,
    handleAutoCompleteSelectedSeller,
    paymentOptions,
    temFormaPagamentoSelecionada,
    reprocessarBoleto,
    reprocessandoBoleto,
    handleReprocessarBoletoVenda,
    transportOptions,
    costCenterOptions,
    handleSearchTransport,
    handleAutoCompleteSelectedTransport,
    values,
    handleSubmit,
    // vem do Formik pelo useForm: fica true enquanto o onSubmit está no ar
    isSubmitting,
    handleChange,
    handleBlur,
    errors,
    touched,
    paymentConditionOptions,
    handleCloseModalSearchProduct,
    modalSearchProduct,
    productOptions,
    handleSearchProduct,
    showCreateProduct,
    handleCreateProduct,
    handleAutoCompleteSelectedProduct,
    handleOpenModalSearchProduct,
    formProduct,
    activeProductSelected,
    handleDeleteProduct,
    handleEditProduct,
    productIsEditing,
    setFieldValue,
    formService,
    serviceIsEditing,
    handleCloseModalSearchService,
    activeServiceSelected,
    modalSearchService,
    cfopOptions,
    handleOpenModalSearchService,
    handleEditService,
    handleDeleteService,
    handleAutoCompleteSelectedService,
    handleDeleteMachine,
    loading,
    validateTab,
    pendenciasDaAba,
    tabs,
    handleZipCode,
    handleSearchCodigoTributario,
    handleAutoCompleteSelectedCodigoTributario,
    activeCodigoTributarioSelected,
    codigoTributarioOptions,
    handleSearchCodigoNBS,
    handleAutoCompleteSelectedCodigoNBS,
    activeCodigoNBSSelected,
    codigoNBSOptions,
    BoletoOpen,
    boletoApiResponse,
    boletoHandleOk,
    handleReprocessarBoletos,
    boletoReprocessing,
    travadoPorBoleto
  } = usePedidoDetalhes(id, clonar);

  return (
    <div style={{ paddingBottom: 51 }} className={'h-[92vh]'}>
      <HeaderComponent text={'Pedido'} className={'mb-5'} onClose={() => { window.location.href = Pedido; }} />
      {/* [30/09] Diz POR QUE os campos estao travados e qual e a saida - campo cinza sem
          explicacao ja virou chamado neste sistema. Fora do modo consulta, que ja trava
          tudo por outro motivo. */}
      {travadoPorBoleto && !duploClick && (
        <Alert severity='info' className={'mb-4'}>
          Esta venda tem boleto emitido. Produtos, serviços, locação, frete, crédito e
          pagamento não podem ser alterados, para o boleto não ficar diferente do contas a
          receber. Para alterar: cancele os boletos no Contas a Receber, salve a venda e
          gere o boleto de novo na guia Financeiro.
        </Alert>
      )}
      <ModalProductSelect
        cfopOptions={cfopOptions}
        productIsEditing={productIsEditing}
        activeProductSelected={activeProductSelected}
        formProduct={formProduct}
        handleCloseModalSearchProduct={handleCloseModalSearchProduct}
        modalSearchProduct={modalSearchProduct}
        modalSearchTitle={'Produto'}
        productOptions={productOptions}
        handleSearchProduct={handleSearchProduct}
        handleAutoCompleteSelectedProduct={handleAutoCompleteSelectedProduct}
        showCreateProduct={showCreateProduct}
        handleCreateProduct={handleCreateProduct}
      />
      <ModalServiceSelect
        cfopOptions={cfopOptions}
        productIsEditing={serviceIsEditing}
        activeProductSelected={activeServiceSelected}
        formService={formService}
        handleCloseModalSearchProduct={handleCloseModalSearchService}
        modalSearchProduct={modalSearchService}
        modalSearchTitle={'Serviço'}
        productOptions={productOptions}
        handleSearchProduct={handleSearchProduct}
        handleAutoCompleteSelectedService={handleAutoCompleteSelectedService}
        handleSearchCodigoTributario={handleSearchCodigoTributario}
        handleAutoCompleteSelectedCodigoTributario={
          handleAutoCompleteSelectedCodigoTributario
        }
        activeCodigoTributarioSelected={activeCodigoTributarioSelected}
        codigoTributarioOptions={codigoTributarioOptions}
        handleSearchCodigoNBS={handleSearchCodigoNBS}
        handleAutoCompleteSelectedCodigoNBS={
          handleAutoCompleteSelectedCodigoNBS
        }
        activeCodigoNBSSelected={activeCodigoNBSSelected}
        codigoNBSOptions={codigoNBSOptions}
        showCreateProduct={showCreateProduct}
        handleCreateProduct={handleCreateProduct}
      />
      <ProcessedBoletosDialog open={BoletoOpen} results={boletoApiResponse} onOk={boletoHandleOk} onReprocessar={handleReprocessarBoletos} reprocessing={boletoReprocessing} />
      <Loader loading={loading}>
        <form
          autoComplete='off'
          onSubmit={handleSubmit}
          name='pedido-detalhes'
          className={'flex flex-col justify-between h-[80%]'}
        >
          <div>
            <TabContext value={tabIndex}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList
                  onChange={handleTabChange}
                  aria-label='lab API tabs example'
                >
                  {tabs.map((item: any) => (
                    <Tab
                      key={item.id}
                      label={item.label}
                      value={item.id}
                      icon={validateTab(item.value)}
                      disabled={isTabBlocked(item.id)}
                      // Tooltip nativo dizendo o que falta. Sem isto o `!` e um
                      // aviso sem resposta: o usuario confere os campos que ve, acha
                      // tudo preenchido, e conclui que o sistema esta errado.
                      title={pendenciasDaAba(item.value)}
                    />
                  ))}
                </TabList>
              </Box>
              <TabFinalidade
                values={values}
                handleChange={handleChange}
                handleBlur={handleBlur}
                errors={errors}
                touched={touched}
                duploClick={duploClick}
              />
              <TabCadastro
                handleZipCode={handleZipCode}
                setFieldValue={setFieldValue}
                cfopOptions={cfopOptions}
                handleSearchCustomer={handleSearchCustomer}
                handleAutoCompleteSelected={handleAutoCompleteSelected}
                customerOptions={customerOptions}
                sellerOptions={sellerOptions}
                handleSearchSeller={handleSearchSeller}
                handleAutoCompleteSelectedSeller={
                  handleAutoCompleteSelectedSeller
                }
                values={values}
                handleChange={handleChange}
                handleBlur={handleBlur}
                errors={errors}
                touched={touched}
                duploClick={duploClick}
                clonar={clonar}
              />
              <TabProduto
                values={values}
                handleOpenModalSearchProduct={handleOpenModalSearchProduct}
                handleDeleteProduct={handleDeleteProduct}
                handleEditProduct={handleEditProduct}
                duploClick={duploClick || travadoPorBoleto}
              />
              <TabServico
                handleOpenModalSearchService={handleOpenModalSearchService}
                values={values}
                handleDeleteService={handleDeleteService}
                handleEditService={handleEditService}
                duploClick={duploClick || travadoPorBoleto}
              />
              <TabFinanceiro
                setFieldValue={setFieldValue}
                costCenterOptions={costCenterOptions}
                paymentOptions={paymentOptions}
                paymentConditionOptions={paymentConditionOptions}
                values={values}
                handleChange={handleChange}
                handleBlur={handleBlur}
                errors={errors}
                touched={touched}
                duploClick={duploClick}
                travadoPorBoleto={travadoPorBoleto}
                temFormaPagamentoSelecionada={temFormaPagamentoSelecionada}
                reprocessarBoleto={reprocessarBoleto}
                reprocessandoBoleto={reprocessandoBoleto}
                handleReprocessarBoletoVenda={handleReprocessarBoletoVenda}
                vendaId={id ? Number(id) : null}
              />
              <TabTransporte
                setFieldValue={setFieldValue}
                transportOptions={transportOptions}
                handleSearchTransport={handleSearchTransport}
                handleAutoCompleteSelectedTransport={
                  handleAutoCompleteSelectedTransport
                }
                values={values}
                handleChange={handleChange}
                handleBlur={handleBlur}
                errors={errors}
                touched={touched}
                duploClick={duploClick}
                travadoPorBoleto={travadoPorBoleto}
              />
              <TabLocacao
                values={values}
                handleChange={handleChange}
                handleBlur={handleBlur}
                handleDeleteMachine={handleDeleteMachine}
                errors={errors}
                touched={touched}
                duploClick={duploClick || travadoPorBoleto}
                setFieldValue={setFieldValue}
              />
              <TabDadosAdicionais
                values={values}
                handleChange={handleChange}
                handleBlur={handleBlur}
                duploClick={duploClick}
              />
              <TabFinalizar
                values={values}
                handleChange={handleChange}
                handleBlur={handleBlur}
                errors={errors}
                touched={touched}
                duploClick={duploClick}
              />
            </TabContext>
          </div>

          <Box className={'flex flex-row gap-4 justify-end mb-4'}>
            {parseInt(tabIndex) === 0 && (
              <Button
                variant='warning'
                onClick={handleBack}
                title={'Listagem'}
                className={'w-[200px]'}
              />
            )}
            {parseInt(tabIndex) !== 0 && (
              <Button
                disabled={parseInt(tabIndex) === 0}
                variant='warning'
                onClick={handleBack}
                title={'Voltar'}
                className={'w-[200px]'}
              />
            )}
            {parseInt(tabIndex) < tabs.length - 1 && (
              <Button
                disabled={parseInt(tabIndex) === tabs.length - 1}
                variant='primary'
                onClick={handleNext}
                title={'Próximo'}
                className={'w-[200px]'}
              />
            )}
            {parseInt(tabIndex) === tabs.length - 1 && (
              <Button
                type={'submit'}
                iconStart={<Save />}
                variant='success'
                title={isSubmitting ? 'Salvando...' : 'Salvar'}
                className={'w-[200px]'}
                // duploClick = registro aberto em modo leitura (duplo clique na
                // listagem). isSubmitting = já tem um envio no ar: sem isso, o
                // segundo clique criava um pedido duplicado. A trava que garante
                // é o ref no onSubmit; aqui é para o usuário VER que está indo,
                // que é o que faltava para ele não clicar de novo.
                disabled={duploClick || isSubmitting}
              />
            )}
          </Box>
        </form>
      </Loader>
    </div>
  );
};
